import React from "react";
import { Camera, MapPin } from "lucide-react";

export const locKey = (label) => String(label || "").trim().replace(/\s+/g, " ").toLowerCase();

/** The room-matching rule the placement records use: building | floor | room number. */
export const roomKey3 = (r) => [r?.building, r?.floor, r?.room_number]
  .map((v) => String(v || "").trim().toLowerCase()).join("|");

/**
 * ONE location cell for every view. The Install Material view, the Delivery view and the FRS
 * picking ticket view ("WHERE IT IS") were the same `<td>` in this grid already — picking mode just
 * rendered the pin list and had its click disabled. They now share this body: each physical location
 * on its own line, the label opening the placement detail, and a camera affordance per location
 * carrying its own photo count. Photos never merge across locations.
 */
export default function LocationCell({
  locations = [], countOf = () => 0, onOpenDetail, onOpenPhotos, testid, compact = false,
}) {
  if (!locations.length) return null;
  return (
    <span className="flex flex-col gap-0.5 leading-tight" data-testid={testid}>
      {locations.map((label) => {
        const n = countOf(label) || 0;
        return (
          <span key={label} className="inline-flex items-center gap-1 min-w-0">
            <MapPin className="w-3 h-3 shrink-0 text-gray-500" />
            <button type="button" disabled={!onOpenDetail}
                    onClick={onOpenDetail ? () => onOpenDetail(label) : undefined}
                    title={onOpenDetail ? "Open the placement detail" : label}
                    data-testid={`${testid}-label-${label}`}
                    className={`truncate text-left ${onOpenDetail ? "text-blue-700 hover:underline" : "text-gray-700"}`}>
              {label}
            </button>
            {onOpenPhotos && (
              <button type="button" onClick={() => onOpenPhotos(label)}
                      title={n ? `${n} material photo(s) at ${label}` : `Photograph the material at ${label}`}
                      data-testid={`${testid}-photos-${label}`}
                      className={`shrink-0 inline-flex items-center justify-center gap-0.5 rounded border px-1 min-h-[30px] min-w-[30px] sm:min-h-0 sm:min-w-0 sm:px-0.5 ${
                        n ? "border-blue-300 bg-blue-50 text-blue-800" : "border-gray-200 text-gray-400 hover:text-blue-700"}`}>
                <Camera className="w-3.5 h-3.5 sm:w-3 sm:h-3" />
                {n > 0 && <span className="text-[9px] font-semibold tabular-nums">{n}</span>}
              </button>
            )}
          </span>
        );
      })}
      {compact && null}
    </span>
  );
}
